export default __webpack_public_path__ + "static/media/settlement-back.d140de84.png";